export default __webpack_public_path__ + "static/media/gallery-12-1.2dfc65c6.webp";